<template>
    <el-dialog title="选择小程序" :visible.sync="innerVisible" class="dialog-table" width="700px" :before-close="closeDialogTable">
        <div class="tableTh">
            <el-table :data="tableData" border ref="multipleTable" @current-change="handleSelectionChange" @row-click="handleRowClick" style="width: 100%" height="100%" class="tableStyle table-radio">
                <!-- <el-table-column type="selection" width="60" align="center">
                </el-table-column> -->
                <el-table-column align="center" width="60" label>
                   <template slot-scope="scope">
                        <el-checkbox @change.native="handleSelectionChange(scope.row)" v-model="selected" :label="scope.row.appId"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="appId" label="小程序ID">
                </el-table-column>
                <el-table-column prop="name" label="小程序名">
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
var appname = ''
// var appnameList = []
var appid = ''
// var appidList = []
export default {
    name: 'AppTableMore',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        selectApp: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            tableData: {},
            currentPage: 1,
            pageSize: 100,
            currentRow: ''
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            this.$nextTick(()=>{
                this.$refs.multipleTable.clearSelection();
                if (this.selectApp.length > 0) {
                    this.tableData.forEach(item => {
                        this.selectApp.forEach(row => {
                            if(item.appId == row.appId){
                                this.$refs.multipleTable.toggleRowSelection(item, true);
                                this.selected = [item.appId]
                                console.log('设置',row)
                            }
                        });
                    })
                    
                }else{
                    this.selected = []
                }
            })
        },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        },
    },
    mounted() {
        this.tableData = JSON.parse(localStorage.getItem('appList'))
    },
    methods: {
        handleRowClick(row) {
            console.log("row",row)
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        // 多选
        handleSelectionChange(val) {
            // appidList = []
            // appnameList = []
            // val.forEach((item) => {
            //     appidList.push(item.appId)
            //     appnameList.push(item.name)
            // })
            // appname = appnameList.toString()
            // appid = appidList.toString()
            appname = val.name
            appid = val.appId
            this.currentRow = val
            this.$refs.multipleTable.setCurrentRow(val);
            this.selected = [val.appId]
        },
        // 确定按钮
        tableSureBtn() {
            // this.$emit('appSure', this.currentRow);
            this.$emit('appSure', {
                currentRow: this.currentRow,
                appname: appname, 
                appid: appid
            });
            this.$emit('cancelDialogApp', false);
        },
        // 关闭弹框
        closeDialogTable () {
            console.log('关闭弹框')
            this.$emit('cancelDialogApp', false);
        }
    }
}
</script>
